export const sliderActionTypes = {
  NEXT: 'NEXT',
  PREVIOUS: 'PREVIOUS',
  DOT: 'DOT',
}
